import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, Button, Dialog, DialogActions, DialogTitle, Alert, Snackbar  } from '@mui/material'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  contAddBlockH1:{
    padding:'40px 0 0px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  firstDiv:{
    padding:'20px 10px',
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #ddd',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  secondDiv:{
    padding:'20px 10px',
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #ddd',


    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'250px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center',
    }
  },
  fistTextField:{
    marginLeft:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px'
    }
  },
  buttonbutton:{
    marginLeft:'10px',
    display:'flex',
    alignItems:'center'
  },
  button:{
    [theme.breakpoints.down(1025)]: {
      padding:'100px'
    }
  },
  ItemConfigLiReactQuill:{
    display:'flex',    
    padding:'0px 0 40px 10px',
    borderBottom:'1px solid #ddd',
    height:'400px',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      
    },
  },
  ItemConfigSpanReactQuill:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      textAlign:'center',
      padding:'10px 0'
      
    },
  },
  reactQuill:{
    width:'800px',
    height:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
      height:'270px'
      
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    padding:'10px 0'
  },

}));


const ContAdd = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();

  const [idCheck, setIdCheck] = useState(false) 
  const [coId, setCoId] = useState('') 
  const [coSubject, setCoSubject] = useState('') 
  const [coContent, setCoContent] = useState('') 

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [dialog, setDialog] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setIdCheck(false)
      setCoId('')
      setCoSubject('')
      setCoContent('')
    }
  }, [])


  const onSubmit = async() => {
    if (!idCheck) return setDialog('아이디 중복확인을 해주세요.') ;
    if (coSubject === '') return setDialog('제목을 입력해주세요.') ;
    if (coContent === '') return setDialog('내용을 입력해주세요.') ;

    try {
      const res = await axios.post(
        '/api/adm/addContent/', 
        {
          co_id: coId,
          co_subject: coSubject,
          co_content: coContent,
        }
        )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
      
      setSuccSnack(true)
      navigate("/DashboardMain/contConfig");
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }

  const onCheckId = async() => {
    try {
      const res = await axios.post('/api/adm/checkContent/', {co_id: coId})

      if(res.data.success === false) {
        setIdCheck(false)
        setDialog('현재사용중인 아이디 입니다.')
        return ;
      }
      
      setIdCheck(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.contAddBlock}>
      <div className={classes.box}>
        <h1 className={classes.contAddBlockH1}>내용관리 추가</h1>
        <div className={classes.firstDiv}>
          <span className={classes.spanSpan}>ID</span>
          <div className={classes.fistTextField}>
            <TextField 
              style={{ width:220 }}
              hiddenlabel="true" 
              variant="outlined" 
              value={coId}
              onChange={(e) => {
                setIdCheck(false)
                setCoId(e.target.value)
              }}
            />
          </div>
          <div className={classes.buttonbutton}>
            <div>
              <Button 
                variant="text" 
                onClick={() => onCheckId()}
                style={{ background:'#007235', color:'#fff',}}
              >
                중복확인
              </Button>
            </div>
            <div>
              {idCheck && (
                <h6>사용 가능한 아이디 입니다.</h6>
              )}
            </div>
          </div>
        </div>
        <div className={classes.secondDiv}>
          <span className={classes.spanSpan}>제목</span>
          <div className={classes.fistTextField}>
            <TextField 
              style={{ width:220 }}
              hiddenlabel="true" 
              variant="outlined" 
              value={coSubject}
              onChange={(e) => {setCoSubject(e.target.value)}}
            />
          </div>
        </div>
        <div className={classes.ItemConfigLiReactQuill}>
          <span className={classes.ItemConfigSpanReactQuill}>내용</span>
          <ReactQuill 
            theme="snow" 
            value={coContent}
            onChange={(content, delta, source, editor) => {setCoContent(editor.getHTML())}}
            className={classes.reactQuill} 
          />
        </div>
  
          <div className={classes.btnDiv}>
            <Button 
              variant="text" 
              onClick={() => onSubmit()}
              style={{ background:'#007235', color:'#fff'}}
            >
              확인
            </Button>
            <Button 
              variant="text" 
              onClick={() => {
                navigate("/DashboardMain/contConfig");
              }}
              style={{ border:'1px solid #007235', margin:'0 10px'}}
            >
              목록
            </Button>
          </div>
  
        <Snackbar 
          open={errSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="error">수행을 실패 하였습니다!</Alert>
        </Snackbar>
        <Snackbar 
          open={succSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="success">수행을 성공 하였습니다!</Alert>
        </Snackbar> 
        <Dialog
          open={dialog === '' ? false : true}
          onClose={() => setDialog('')}
        >
          <DialogTitle id="alert-dialog-title">
            {dialog}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setDialog('')} autoFocus>
              확인
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  )
}

export default ContAdd
